import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    timeFormatter,
    dateValueGetter,
    timeValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.communicationChannel, "myCommunicationChannel"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: 'code',
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },

    {
        pages: [paths.communicationChannel, "myCommunicationChannel"],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: 'name',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.communicationChannel, "myCommunicationChannel"],
        config: {
            headerName: getLocalizedString("income"),
            field: 'date',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },

    {
        pages: [paths.communicationChannel, "myCommunicationChannel"],
        config: {
            headerName: getLocalizedString("entryTime"),
            field: 'time',
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.communicationChannel],
        config: {
            headerName: getLocalizedString("daysElapsed"),
            field: 'daysPassed',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.communicationChannel],
        config: {
            headerName: getLocalizedString("communicationType"),
            field: 'typeString',
            filter: "agSetColumnFilter",
            cellRenderer: "CommunicationChannelStatusRenderer",
        }
    },
    {
        pages: [paths.communicationChannel, "myCommunicationChannel"],
        config: {
            headerName: getLocalizedString("communicationStatus"),
            field: 'statusString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.communicationChannel, "myCommunicationChannel"],
        config: {
            headerName: getLocalizedString("attentionResponsible"),
            field: 'responsibleName',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.communicationChannel, "myCommunicationChannel"],
        config: {
            headerName: getLocalizedString("actionsOrResponsesCount"),
            field: 'actionsQuantity',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.communicationChannel],
        config: {
            headerName: getLocalizedString("attachmentsCount"),
            field: 'attachmentsAmount',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.communicationChannel, "myCommunicationChannel"],
        config: {
            headerName: getLocalizedString("assignmentDateToResponsible"),
            field: 'responsibleDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.communicationChannel, "myCommunicationChannel"],
        config: {
            headerName: getLocalizedString("responsibleAssignmentTime"),
            field: 'responsibleTime',
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.communicationChannel,],
        config: {
            headerName: getLocalizedString("responsibleAssigner"),
            field: 'allocatorName',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.communicationChannel],
        config: {
            headerName: getLocalizedString("clasification"),
            field: 'classificationString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.communicationChannel, "myCommunicationChannel"],
        config: {
            headerName: getLocalizedString("comments"),
            field: 'comment',
            cellRenderer: "RichTextRenderer",
        }
    },
    {
        pages: [paths.communicationChannel, "myCommunicationChannel"],
        config: {
            headerName: getLocalizedString("completionDate"),
            field: 'endDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
]